/**
 * feature-config flag names owned by developer-platform
 *
 * please consider removing this file and adding it to an appropriate place in the
 * feature code (e.g. an entrypoint, or a package owned by the feature team), or
 * passing flag names directly as a string!
 *
 * by separating it out, we decouple the feature code from the feature config packages
 * and avoid the need to update this package when flags are added or removed.
 */

export const DEVELOPER_PLATFORM_FLAG_NAMES = {
  ALLOW_LIST_FOR_V1_PUBLIC_API_DEPRECATION: 'ff-devpl-2536-deprecate-v1-apis',
  APP_BADGES: 'ff-devpl-3490-marketplace-app-badges',
  APP_BADGES_API: 'ff-devpl-3490-marketplace-app-badges-api',
  BULK_SCHEMA_MARKUP_API: 'ff-sd-408-bulk-schema-markup-api',
  // Authorizes the bulk schema-markup write per page, so Designer, Marketer
  // and Content editor pass where the Designer lets them (EXT-2595). Off = the
  // site-scoped check, which only Site managers pass, as before.
  BULK_SCHEMA_MARKUP_PER_PAGE_AUTHORIZATION:
    'ff-ext-2595-bulk-schema-markup-per-page-authorization',
  APP_DELETION: 'ff-devpl-2900-app-deletion',
  APP_DEVELOPER_WORKSPACE_BANNER: 'ff-devpl-3029-app-developer-plan-banner',
  APP_INTEGRATION_RENAME: 'ff-devpl-3714-rename-app-to-integration',
  APP_MODES_BUILD_MODE: 'ff-devpl-3896-app-modes-build-mode',
  APP_MODE_NOTIFICATIONS: 'ff-devpl-3603-app-mode-notifications',
  APP_MODES_DESIGNER_EXTENSION_APIS: 'devpl-2112-de-app-modes',
  APP_QUICK_INSTALL: 'ff-devpl-2713-apps-panel-quick-install',
  APP_SEARCH_METRICS: 'ff-devpl-3629-marketplace-search-index-metrics',
  APP_SETTINGS_LOCKDOWN: 'ff-devpl-2997-app-settings-lockdown',
  APP_SUGGESTIONS_FOR_FORM_ELEMENTS: 'ff-devpl-3260-suggested-apps-for-forms',
  APP_TEST_USER_INSTALLATION: 'ff-devpl-2926-invite-app-installations',
  DESIGNER_EXTENSION_PUBLISHING: 'ff-devpl-3527-designer-extension-publishing',
  DESIGNER_EXTENSION_BULK_APP_CONNECTIONS:
    'ff-cam-1571-designer-extension-bulk-app-connections',
  ENABLE_APP_ANALYTICS_NOTIFICATIONS:
    'ff-devpl-2200-enable-app-analytics-notifications',
  ENTERPRISE_RATE_LIMIT_OVERRIDE:
    'ff-devpl-2764-enterprise-rate-limit-override',
  // Resolve the owning site's plan rate limit on /v2/pages/:page_id and
  // /v2/assets/:asset_id, which carry no site in the path (EXT-2314). Off =
  // those routes stay on the token's default limit, as before.
  SITE_PLAN_RATE_LIMIT_FOR_PAGE_AND_ASSET_ROUTES:
    'ff-ext-2314-site-plan-rate-limit-page-asset-routes',
  // Return workspace roles on GET /v2/token/authorized_by (the installer's
  // roles) and POST /v2/token/resolve (the current Designer user's role in the
  // resolved site's workspace) (EXT-3263). Evaluated with the OAuth application
  // ID as Statsig customId, so target apps by customId. Off = no workspaces
  // field.
  AUTHORIZED_BY_WORKSPACE_ROLE: 'ff-ext-3263-authorized-by-workspace-role',
  SHOW_LEGACY_TOKEN_GENERATION: 'ff-devpl-2485-show-legacy-token-generation',
  SITE_LEVEL_APP_INSTALL_BYPASS: 'ff-devpl-2348-site-level-app-install-bypass',
  TURNSTILE_KILLSWITCH: 'ff-devpl-2408-turnstile-killswitch',
  GOOGLE_ADS_INTEGRATIONS_CTA: 'ff-devrel-2700-google-ads-integrations-cta',
  GOOGLE_TAG_GATEWAY: 'ff-devpl-3371-google-tag-gateway',
  MULTIPLE_GOOGLE_TAG_IDS: 'ff-devpl-3437-multiple-google-tag-ids',
  GOOGLE_TAG_GATEWAY_XOR_BASE64_ENCODER: 'ff-devpl-3550-gtg-xor-base64-encoder',
  // Renders native Google tags after head custom code and app scripts, so a
  // CMP / consent default can run before the tag fires (EXT-2657).
  GOOGLE_TAG_AFTER_CUSTOM_CODE: 'ff-ext-2657-google-tag-after-custom-code',
  AI_WORKFLOWS_UI: 'ff-devpl-3664-ai-workflows-ui',
  AI_WORKFLOWS_BACKEND: 'ff-devpl-3664-ai-workflows-backend',
  AIA_WORKFLOWS_MCP: 'ff-devpl-4208-aia-workflows-mcp',
  // Master kill-switch for the NestJS @McpTool() autodiscovery path (CAM-678).
  NEST_MCP_AUTODISCOVERY: 'ff-cam-678-nest-mcp-autodiscovery',
  // Per-domain gate for the campaigns @McpTool() endpoints (CAM-678).
  CAMPAIGNS_MCP: 'ff-cam-678-campaigns-mcp',
  ENABLE_STIGG_FOR_FILE_UPLOAD_LIMIT:
    'ff-devpl-3728-read-file-upload-limit-from-stigg',
  FREE_WORKSPACE_EMAIL_DESTINATION_RESTRICTION:
    'ff-devpl-3758-free-workspace-form-email-destination-restriction',
  CUSTOM_CODE_FREEFORM_DATA_API: 'ff-devpl-4351-page-head-body-code-data-api',
  HTMLEMBED_DOM_API: 'ff-devpl-4002-htmlembed-dom-api',
  MAILJET_SEPARATE_CREDENTIALS: 'ff-devpl-3798-mailjet-separate-credentials',
  MAILJET_FAILOVER_TO_FREE_CREDENTIALS:
    'ff-devpl-3798-mailjet-failover-to-free-credentials',
  OAUTH_BLOCK_INVALID_RESPONSE_TYPE:
    'ff-devpl-3300-oauth-block-invalid-response-type',
  OAUTH_OWNER_ACCESS_WARNING: 'ff-devpl-4743-oauth-owner-access-warning',
  OAUTH_SCOPE_SELECT: 'ff-aio-208-oauth-scope-select',
  EXCLUDE_PASSWORD_PAGE_FORMS: 'ff-devpl-3803-exclude-password-page-forms',
  HIDE_ORPHAN_FORM_ROWS: 'ff-devpl-4456-hide-orphan-form-rows',
  HIDE_STALE_FORM_NAMES: 'ff-devpl-4607-hide-stale-form-names',
  FIX_SPAM_FILE_UPLOAD_NOT_SPAM: 'ff-devpl-3582-fix-spam-file-upload-not-spam',
  FETCH_AWR_FROM_OPENSEARCH: 'ff-devpl-3776-fetch-awr-from-opensearch',
  FORM_EMAIL_DESTINATION_FORMAT_VALIDATION:
    'ff-devpl-3977-form-email-destination-format-validation',
  SITE_LEVEL_FORM_DEFAULTS: 'ff-devpl-3599-site-level-form-defaults',
  FORM_LEVEL_EMAIL_DISABLE: 'ff-devpl-4385-form-level-email-disable',
  SYMBOL_FORM_COMPONENT_ID_FIX: 'ff-devpl-3905-symbol-form-component-id-fix',
  CORS_VALIDATION: 'ff-devpl-3946-cors-validation',
  CUSTOM_CODE_ORDERING: 'ff-devpl-3701-custom-code-ordering',
  CUSTOM_FONTS_DATA_API: 'ff-devpl-4393-custom-fonts-data-api',
  ASSETS_COMPRESS_API: 'ff-devpl-4774-assets-compress-api',
  PUBLISH_WEBHOOK_PUBLISHER_ATTRIBUTION:
    'ff-devpl-4678-publish-webhook-publisher-attribution',
  FORM_SUSPENSION_NOTICE: 'ff-devpl-4193-form-suspension-notice',
  FORM_BODY_HASH_COLLISION_MONITORING:
    'ff-devpl-4194-form-body-hash-monitoring',
  EXCLUDE_FIELDS_FROM_FORM_SUBMISSION:
    'ff-devpl-3996-exclude-fields-from-form-submission',
  MARKETPLACE_MCP_CONNECTORS_CATEGORY:
    'ff-devrel-marketplace-mcp-connectors-category',
  MARKETPLACE_WEBFLOW_OPTIMIZE_CATEGORY:
    'ff-devrel-marketplace-webflow-optimize-category',
  MARKETPLACE_CAMPAIGNS_CATEGORY: 'ff-devrel-marketplace-campaigns-category',
  MARKETPLACE_SEARCH_INDEX_TARGET:
    'ff-devrel-2949-marketplace-search-index-target',
  DE_THEME_API: 'ff-devpl-4117-de-theme-api',
  APP_LIFECYCLE_CLEANUP: 'ff-devpl-3593-app-lifecycle-cleanup',
  APP_LIFECYCLE_REGISTERED_SCRIPTS_CLEANUP:
    'ff-devpl-1444-app-lifecycle-registered-scripts-cleanup',
  DASHBOARD_HOME_APP_RECOMMENDATIONS:
    'ff-devrel-2947-dashboard-home-app-recommendations',
  DASHBOARD_LOCALIZATION_APP_RECOMMENDATIONS:
    'ff-devrel-2882-dashboard-localization-app-recommendations',
  DASHBOARD_FORMS_APP_RECOMMENDATIONS:
    'ff-devrel-2883-dashboard-forms-app-recommendations',
  DASHBOARD_CUSTOM_CODE_APP_RECOMMENDATIONS:
    'ff-devrel-2884-dashboard-custom-code-app-recommendations',
  // ON → the hardcoded single-app integration promos (Google site tools,
  // Google Ads) render as the recommendation-widget card; OFF → the legacy
  // Spring Note "Get the App" CTA.
  USE_NEW_DASHBOARD_SINGLE_APP_RECOMMENDATIONS_CARD:
    'ff-devrel-3021-dashboard-single-app-recommendations-card',
  // Gates the installed-apps read cutover in getInstalledAppsAcrossWorkspace:
  // ON → single indexed query on the denormalized workspaceId; OFF → legacy
  // Site-union query with the 2000-site cap / too-many-sites sentinel. Kept
  // separate from the unconditional write/backfill so the read can be ramped
  // (and reverted) per workspace only after the backfill is verified complete.
  INSTALLATIONS_WORKSPACE_ID_READ:
    'ff-devrel-2999-installations-workspace-id-read',
  MARKETPLACE_RECOMMENDATIONS_PAGE:
    'ff-devrel-3012-marketplace-recommendations-page',
  // When on, applyCloudflareCacheControlHeaders honors the entitlement's
  // `hasAccess`. When off, it keeps the legacy behavior where the resolved
  // entitlement object is treated as truthy for any site with a workspace.
  CLOUDFLARE_CACHE_CONTROL_ENTITLEMENT_ACCESS:
    'ff-sub-140-cloudflare-cache-control-entitlement-access',
};

export const DEVELOPER_PLATFORM_DYNAMIC_CONFIG_NAMES = {
  FREE_SITE_EMAIL_DESTINATION_LIMIT:
    'dc-inc-1047-devpl-free-site-email-destination-limit',
  // Cap for paid/non-free sites, distinct from (and looser than) the
  // free-site limit above. Added after a phishing campaign grew one form's
  // emailDestinations to an estimated several hundred harvested addresses on
  // a paid workspace, which had no size limit at all. Lowered from an
  // initial 100 to 50 (TNS-281 follow-up): a broader Snowflake pass found
  // real paid usage essentially never exceeds ~25 recipients (23 forms
  // total, out of ~2.05M paid forms) — 50 still leaves comfortable headroom
  // while roughly halving the fan-out available to a compromised form. The
  // rare legitimate accounts above 50 (e.g. a 122-352-recipient CMS-plan
  // site) get a per-site dynamic-config override rather than raising this
  // default to cover them — see the TNS-281 ticket history for the
  // Snowflake analysis and exemption list.
  SITE_EMAIL_DESTINATION_LIMIT: 'dc-devpl-site-email-destination-limit',
  OAUTH_SCOPE_SELECT_CLIENT_IDS: 'dc-devpl-oauth-scope-select-client-ids',
  // Net-new-site cutoff for form recipient email verification. Only sites
  // created on/after `epochMs` are enforced; defaults far-future so enforcement
  // is off until this is set to the intended rollout date. TODO(ticket): rename.
  FORM_RECIPIENT_VERIFICATION_ENFORCEMENT_EPOCH:
    'dc-forms-recipient-verification-enforcement-epoch',
} as const;
